function value(metaName) {
    if (window.bpMetaInfo?.[metaName] === undefined) {
        return '';
    }
    return window.bpMetaInfo?.[metaName];
}

export default {
    value
};
